module.exports = __webpack_public_path__ + "img/transfer16.e7754ed7.jpeg";